module.exports = {"540103001":"东嘎街道","540103002":"乃琼街道","540103003":"羊达街道","540103004":"柳梧街道","540103201":"古荣乡","540103203":"马乡","540103204":"德庆乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540103.json
// module id = 2674
// module chunks = 0